import { Component, OnInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { FetchWithdrawalService } from './fetch-withdrawals.service';
import { CustomSelection, Report, SelectionAction } from '../../../report/report';
import { ChangeWithdrawalStatusService } from './change-withdrawal-status.service';
import Swal from "sweetalert2";

@Component({
  selector: 'app-withdrawals',
  templateUrl: './withdrawals.component.html',
  styleUrls: ['./withdrawals.component.scss']
})
export class WithdrawalsComponent implements OnInit {

  tableColumns: string[] = [
    'transactionId',
    'creditorName',
    'WithdrawType',
    'creditorAccountNumber',
    'AccountType',
    'creditorBank',
    'creditorBankBranchNo',
    'transactionAmount',
    'totalBalance',
	'totalSales',
	'totalWithdrawls',
	'bussinesAvailableBalance',
    'transactionPurpose',
    'comments',
    'businessName',
    'contractStatus',
    'bankBranchName',
    'bankName',
    'status',
    'transfarDate',
  ];

  displayTableColumns = {
    'transactionId': 'Transaction Id',
    'creditorName': 'Creditor Name',
    'creditorAccountNumber': 'Account #',
    'AccountType': 'Account Type',
    'creditorBank': 'Bank Code',
    'creditorBankBranchNo': 'Branch Code',
    'transactionAmount': 'Amount',
    'transactionPurpose': 'Transaction Purpose',
    'comments': 'Comments',
    'businessName': 'Business Name',
    'contractStatus': 'contract Status',
    'bankBranchName': 'Branch Name',
    'bankName': 'Bank Name',
    'status': 'Status',
    'WithdrawType': 'Withdraw Type',
	'bussinesAvailableBalance': 'Bussines Available Balance',
    'totalBalance': 'Total Balance',
    'totalSales': 'Total Sales',
    'totalWithdrawls': 'Total Withdrawls',
    'transfarDate':'Transfar Date'
  };
  totalNumberOfRecords = 0;
  withdrawalData: any[] = [];
  selectionModel = new SelectionModel<any>(true, []);
  filterField = [
    {
      filterFieldName: 'status',
      filterDisplayName: 'Status',
      defaultValue: '',
      filterOptions: [
        { key: 'Show All', value: null },
        { key: 'Accepted', value: 'accepted' },
        { key: 'Pending', value: 'pending' },
        { key: 'Rejected', value: 'rejected' },
        { key: 'Sent to Bank', value: 'sent To Bank' },
      ]
    }, {
      filterFieldName: 'WithdrawType',
      filterDisplayName: 'Withdraw Type',
      defaultValue: '',
      filterOptions: [
        { key: 'Show All', value: null },
        { key: 'Normal', value: 'NORMAL' },
        { key: 'Urgent', value: 'URGENT' },
        { key: 'Normal Recurring', value: 'NORMAL_R' },
        { key: 'Urgent Recurring', value: 'URGENT_R' },
        { key: 'Cashout Wallet', value: 'Cashout Wallet' },
      ]
    }
  ];

  requestBody: Report = {};
  loading = false;

  selectableRows: Array<CustomSelection> = [
    {
      colName: 'status',
      valueIn: ['PENDING', 'ACCEPTED'],
    },
  ];
  selectionActions: SelectionAction[] = [
    {
      actionName: 'Send To Bank',
      actionValue: 'SENT TO BANK',
      actionType: 'Button',
      actionClass: 'btn-primary',
    },
    {
      actionName: 'Rejected',
      actionValue: 'REJECTED',
      actionType: 'Button',
      actionClass: 'btn-outline-danger',
    },
    {
      actionName: 'Accepted',
      actionValue: 'ACCEPTED',
      actionType: 'Button',
      actionClass: 'btn-success',
    },
  ];

  constructor(
    public fetchWithdrawalsService: FetchWithdrawalService,
    private changeWithdrawalStatusService: ChangeWithdrawalStatusService,
  ) { }

  async ngOnInit() {
    this.fetchWithdrawalsService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.fetchWithdrawalsService.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.fetchWithdrawalsService.loader().subscribe(val => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.fetchWithdrawalsService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async selectionTrigger(event: any) {
    this.changeWithdrawalStatusService.setParams({
      obj: this.prepareSelectionUpdateArray(event)
    });
    try {
      await this.changeWithdrawalStatusService.make();
      this.selectionModel.clear();
      await this.updateTable();
      this.fetchWithdrawalsService.loader().subscribe(val => (this.loading = val));
    } catch (err) {
      this.showFailPopup(err.faultyRequest.error.message)
    }
  }

  prepareSelectionUpdateArray(event: any) {
    const action = event.action;
    const output = [];
    for (const item of event.selection) {
      output.push({
        refNumber: item.transactionId,
        newStatus: action,
      });
    }
    return output;
  }
  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.fetchWithdrawalsService.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.fetchWithdrawalsService.activateLoader();
    this.fetchWithdrawalsService.setParams(this.requestBody);
    const report = await this.fetchWithdrawalsService.make();
    this.withdrawalData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }
  showFailPopup(message: string = "Something went wrong. Please try again") {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: message,
    });
  }

}
